import {
    TOGGLE_LOADING, 
    UNAUTHORIZED_INTENT,  
    SIDEBAR_DATA,
    REPORT_ID,
    REPORT_DATA,
    REPORT_DATA_MORE,
    FOLLOW_LIST,
    TRIGGER_LIST,
    TRIGGER_REPORT,
    NEWS_REPORT,
    TRACKING_LIST,
    EMAIL_DATA,
    FOLLOW_LIST_SETUP,
    INDUSTRY_DATA,
    TRIGGER_DATA
    } from "../../constants/IntentActionTypes";
  
  
    const initialState = {
      loading: false,
      unAuthorisedIntent:null,
      sidebarData:null,
      reportId:null,
      reportData:null,
      reportDataMore:null,
      followList:null,
      triggerList:null,
      triggerReport:null,
      newsReport:null,
      trackingList:null,
      emailData:null,
      followListSetup:null,
      industryData:null,
      triggerData:null
    }
  
    const intentReducer = (state = initialState, { type, payload }) => {
      switch (type) {
        case TOGGLE_LOADING:
          return { ...state, loading: payload };
        case UNAUTHORIZED_INTENT:
        return { ...state, unAuthorisedIntent: payload };
        case SIDEBAR_DATA:
        return { ...state, sidebarData: payload };
        case REPORT_ID:
        return { ...state, reportId: payload };
        case REPORT_DATA:
        return { ...state, reportData: payload };
        case REPORT_DATA_MORE:
        return { ...state, reportDataMore: payload };
        case FOLLOW_LIST:
        return { ...state, followList: payload };
        case TRIGGER_LIST:
        return { ...state, triggerList: payload };
        case TRIGGER_REPORT:
        return { ...state, triggerReport: payload };
        case NEWS_REPORT:
        return { ...state, newsReport: payload };
        case TRACKING_LIST:
        return { ...state, trackingList: payload };
        case EMAIL_DATA:
        return { ...state, emailData: payload };
        case FOLLOW_LIST_SETUP:
        return { ...state, followListSetup: payload };
        case INDUSTRY_DATA:
        return { ...state, industryData: payload };
        case TRIGGER_DATA:
        return { ...state, triggerData: payload };
        default:
          return state;
      }
    };
  
    export default intentReducer;
  